<dx-select-box
  [items]="campaignDs"
  valueExpr="id"
  displayExpr="name"
  [disabled]="true"
  [searchEnabled]="true"
  searchExpr="name"
  [(value)]="value"
  (onValueChanged)="save($event)"
  (onInitialized)="onInitialized($event)"
></dx-select-box>
